export const inlineImageSrcRegex =
  /((src\s*=\s*["']cid(?::|%3[aA]d)[^"']*["'])|(\[cid(?::|%3[aA]d)[^\]]*\]))/gi;

export const stripInlinePrefix = (value = '') =>
  value
    .trim()
    .replace(/^\[/, '')
    .replace(/\]$/, '')
    .replace(/^src\s*=\s*/i, '')
    .replace(/^['"]|['"]$/g, '')
    .replace(/^cid(?::|%3[aA]d)/i, '')
    .replace(/^<|>$/g, '')
    .trim()
    .toLowerCase();

const stripInlineFilePrefix = (value = '') =>
  value.replace(/^(inline-img-)/i, '').trim();

const getBaseIdentifier = (value = '') => {
  const normalizedValue = stripInlinePrefix(value);
  return normalizedValue.split('@')[0];
};

type InlineMatch = RegExpMatchArray | string;

interface InlineAttachmentCandidate {
  contentId?: string;
  name?: string;
}

export const findMatchingInlineImageReference = (
  matches: InlineMatch[] = [],
  attachment: InlineAttachmentCandidate = {}
) => {
  const candidates = new Set<string>();
  const values = [
    attachment.contentId,
    attachment.name,
    stripInlineFilePrefix(attachment.name),
  ].filter(Boolean);

  values.forEach((value) => {
    const normalizedValue = stripInlinePrefix(value);
    if (!normalizedValue) {
      return;
    }
    candidates.add(normalizedValue);
    const baseIdentifier = getBaseIdentifier(normalizedValue);
    if (baseIdentifier) {
      candidates.add(baseIdentifier);
    }
  });

  return (
    matches.find((match) => {
      const rawValue = Array.isArray(match) ? match[0] : match;
      const normalizedMatch = stripInlinePrefix(rawValue);
      if (!normalizedMatch) {
        return false;
      }

      const matchCandidates = new Set<string>([normalizedMatch]);
      const baseIdentifier = getBaseIdentifier(normalizedMatch);
      if (baseIdentifier) {
        matchCandidates.add(baseIdentifier);
      }

      if (Array.from(candidates).some((candidate) => matchCandidates.has(candidate))) {
        return true;
      }

      return false;
    }) ?? null
  );
};
